export default __webpack_public_path__ + "static/is-bao-919bca84981730fb63cd094a21f3f4f7.png";